import { useWorkspaceId } from "../../hooks/useWorkspaceId";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useHttpTaxManagerAppHeaders } from "../utils/useHttpTaxManagerAppHeaders";
import { BASE_API_URL, HttpError } from "../utils/useTaxManagerAppQueryClient";

interface DeleteActivityNoteRequest {
    activityId: string;
    levyId: string;
    taxPayerWorkspaceId: string;
    year: number;
}

export function useDeleteActivityNote() {
    const { t } = useTranslation();
    const workspaceId = useWorkspaceId();
    const headers = useHttpTaxManagerAppHeaders();
    const queryClient = useQueryClient();

    const mutation = useMutation<boolean, Error, DeleteActivityNoteRequest>({
        mutationFn: async (request) => {
            const response = await fetch(
                `${BASE_API_URL}/tenants/${workspaceId}/fulfilments/${request.levyId}/years/${request.year}/tax-payers/${request.taxPayerWorkspaceId}/activities/${request.activityId}/notes`,
                {
                    headers,
                    method: "DELETE",
                },
            );

            if (!response.ok) {
                throw new HttpError(response);
            }

            return true;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["useGetFulfilmentActivities"],
            });
        },
        meta: {
            errorMessage: t("errors.messages.deleteActivityNote"),
        },
    });

    return mutation;
}
